/*eslint-disable*/
import {
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  Icon,
  Typography
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import { GetUserId, GetUserToken } from "helpers/UserHelper";
import _ from "lodash";
import { InviteUsers } from "queries/user_management/ChangeUserStatus";
import React from "react";
import { compose, graphql } from "react-apollo";
import { change, Field, reduxForm, unregisterField, untouch } from "redux-form";
import store from "store";
import {
  successWarning,
  showSnack
} from "../../../reducers/NotificationReducer";

const required = value => (value ? undefined : "Required");

const email = value => {
  if (!value) return undefined;

  let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  return value.match(mailformat) ? undefined : "Not a Valid Email Addres";
};

const initialState = {
  users: {
    brokers: [],
    assistants: []
  },
  checkValidation: false,
  addedUsers: {
    broker: 0,
    assistant: 0
  }
};

class InviteUsersModal extends React.Component {
  state = { ...initialState };

  closeDialog = (willRefetch = false) => {
    this.setState({ ...initialState });
    this.props.onClose(willRefetch);
  };

  checkAvailableSlots(userType, addedUsers) {
    let activeCount = this.props.activeCount[userType] + addedUsers;
    let limit = this.props.userLimits[userType];

    if (activeCount >= limit) {
      store.dispatch(
        showSnack({
          message: "Not enough " + userType + " slots available.",
          color: "danger"
        })
      );

      return false;
    }
    return true;
  }

  addUser = (userType, userTypeEx) => {
    let users = [...this.state.users[userType]];

    if (!this.checkAvailableSlots(userTypeEx, users.length)) return;

    let id = 0;

    if (users.length > 0) {
      let max = Math.max.apply(
        Math,
        users.map(function(b) {
          return b.id;
        })
      );
      id = max + 1;
    }

    users.push({
      id: id,
      component: checkValidation => (
        <div style={{ display: "flex" }}>
          <Button
            variant="fab"
            mini
            className="smallFab"
            style={{ position: "relative", top: "15px", marginRight: "15px" }}
            onClick={() => this.removeUser(id, userType, userTypeEx)}
          >
            <Icon>delete</Icon>
          </Button>

          <FormControl fullWidth>
            <Field
              component={FormInput}
              isrequired={true}
              validate={[required, email]}
              checkValidation={checkValidation}
              name={userType + "." + id + ".email"}
              label="Email *"
            />
          </FormControl>
        </div>
      )
    });

    let usersObj = { ...this.state.users };

    usersObj[userType] = users;

    let addedUsers = { ...this.state.addedUsers };
    addedUsers[userTypeEx] = addedUsers[userTypeEx] + 1;

    this.setState({ users: usersObj, addedUsers: addedUsers });
  };

  removeUser = (id, userType, userTypeEx) => {
    let users = [...this.state.users[userType]];

    users = users.filter(b => b.id !== id);

    let usersObj = { ...this.state.users };
    usersObj[userType] = users;

    let addedUsers = { ...this.state.addedUsers };
    addedUsers[userTypeEx] = addedUsers[userTypeEx] - 1;

    this.setState({ users: usersObj, addedUsers: addedUsers });

    store.dispatch(unregisterField("InviteUsersModal", userType + "." + id));
    store.dispatch(change("InviteUsersModal", userType + "." + id, null));
    store.dispatch(untouch("InviteUsersModal", userType + "." + id));
  };

  onInvite = () => {
    if (store.getState().form.InviteUsersModal.syncErrors) {
      store.dispatch(
        showSnack({
          message: "Invalid Information",
          color: "danger"
        })
      );
      this.setState({ checkValidation: true });
      this.forceUpdate();
      return;
    }

    let brokers = _.get(
      store.getState().form,
      "InviteUsersModal.values.brokers",
      []
    );
    let assistants = _.get(
      store.getState().form,
      "InviteUsersModal.values.assistants",
      []
    );

    const input = {
      brokerageId: GetUserId(),
      token: GetUserToken(),
      inviteList: {
        brokers: brokers,
        assistants: assistants
      }
    };

    this.props
      .InviteUsers({
        variables: {
          input
        }
      })
      .then(resp => {
        store.dispatch(
          successWarning({
            open: true,
            title: "Users Invited!",
            onConfirm: () => this.closeDialog(true)
          })
        );
      })
      .catch(error => {
        console.log("err", error);
      });
  };

  calculateUserSlots = () => {
    let activeCount = { ...this.props.activeCount };
    let limit = { ...this.props.userLimits };
    let userSlots = [];

    Object.keys(activeCount).map(k => {
      let typename = k;
      typename = typename.charAt(0).toUpperCase() + typename.substring(1);
      userSlots.push({
        type: typename,
        slots: limit[k] - (activeCount[k] + this.state.addedUsers[k])
      });
      return k;
    });

    return userSlots;
  };

  render() {
    let userSlots = this.calculateUserSlots();
    return (
      <React.Fragment>
        <Dialog
          open={this.props.open}
          onClose={() => this.closeDialog()}
          aria-labelledby="form-dialog-title"
          className="centerFixedDialog"
        >
          <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
            {"Invite Users"}
            <div
              style={{
                borderBottom: "1px solid #cccccc69",
                margin: "5px auto",
                width: "25%"
              }}
            />
            <Typography variant="caption" style={{ marginBottom: "5px" }}> Invite Brokers and/or Assistants to your Brokerage to use Sure Quote</Typography>
          </DialogTitle>
          
          <DialogContent>
            <Grid container>
              <GridItem
                xs={12}
                sm={12}
                md={6}
                style={{
                  marginBottom: "25px"
                }}
              >
                <Card
                  style={{
                    height: "300px",
                    maxHeight: "300px",
                    overflowY: "auto"
                  }}
                >
                  <CardContent>
                    <Grid container>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          margin: "0px auto 15px auto",
                          textAlign: "center"
                        }}
                      >
                        <Typography variant="subheading">Brokers</Typography>
                        <Typography variant="caption">
                          Slots:{" "}
                          {userSlots.find(u => u.type === "Broker").slots}
                        </Typography>
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ margin: "0px auto", textAlign: "center" }}
                      >
                        <Chip
                          label="Add"
                          onClick={() => this.addUser("brokers", "broker")}
                        />
                      </GridItem>

                      {this.state.users.brokers.map(b => {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            style={{ margin: "0px auto", textAlign: "center" }}
                          >
                            {b.component(this.state.checkValidation)}
                          </Grid>
                        );
                      })}
                    </Grid>
                  </CardContent>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Card
                  style={{
                    height: "300px",
                    maxHeight: "300px",
                    overflowY: "auto"
                  }}
                >
                  <CardContent>
                    <Grid container>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          margin: "0px auto 15px auto",
                          textAlign: "center"
                        }}
                      >
                        <Typography variant="subheading">Assistants</Typography>
                        <Typography variant="caption">
                          Slots:{" "}
                          {userSlots.find(u => u.type === "Assistant").slots}
                        </Typography>
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ margin: "0px auto", textAlign: "center" }}
                      >
                        <Chip
                          label="Add"
                          onClick={() =>
                            this.addUser("assistants", "assistant")
                          }
                        />
                      </GridItem>

                      {this.state.users.assistants.map(a => {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            style={{ margin: "0px auto", textAlign: "center" }}
                          >
                            {a.component(this.state.checkValidation)}
                          </Grid>
                        );
                      })}
                    </Grid>
                  </CardContent>
                </Card>
              </GridItem>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.closeDialog()} color="primary">
              Cancel
            </Button>
            {this.state.users.brokers.length > 0 ||
            this.state.users.assistants.length > 0 ? (
              <Button color="primary" onClick={() => this.onInvite()}>
                {" "}
                Invite
              </Button>
            ) : null}
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

InviteUsersModal = reduxForm({
  form: "InviteUsersModal",
  destroyOnUnmount: true
})(InviteUsersModal);

InviteUsersModal = compose(graphql(InviteUsers, { name: "InviteUsers" }))(
  InviteUsersModal
);

export default InviteUsersModal;



// WEBPACK FOOTER //
// ./src/views/UserManagement/components/InviteUsersModal.jsx